/**
 * Utility functions for managing playbook first messages in sessionStorage
 * This handles the flow where a query is saved temporarily when a playbook is created
 * and then automatically sent as the first message when the playbook page loads
 */
const getMessageKey = (playbookId: string) =>
  `playbook-first-message-${playbookId}`

export const setPlaybookFirstMessage = (
  playbookId: string,
  message: string
) => {
  sessionStorage.setItem(getMessageKey(playbookId), message)
}

export const getPlaybookFirstMessage = (playbookId: string): string | null => {
  return sessionStorage.getItem(getMessageKey(playbookId))
}

export const clearPlaybookFirstMessage = (playbookId: string) => {
  sessionStorage.removeItem(getMessageKey(playbookId))
}
